module.exports = __webpack_public_path__ + "img/achtertuin Luts na.a7de0320.jpg";